<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == "ven-contas-receber") {
            next({ name: "ven-contas-receber-list" });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == "ven-contas-receber") {
            let cookie = this.$cookies.get('ven-contas-receber') || 'list' ;
            this.$router.push({ name: `ven-contas-receber-${cookie}` });
        }
    },
};
</script>